/**
 * @file 页面配置需要的常量
 * @author caixiaowen
 */
const wordLimit = {
    // 昵称长度限制
    nicknameMaxLen: 30,
    // 搜索字数限制
    searchMaxLength: 38,
    // 回复字数限制
    replyMaxLen: 2000,
    // 发帖字数限制
    contentMaxLen: 5000
};

// 官方流程状态
export const officialProcessMap = {
    OP_PENDING: '待解决',
    OP_PROCESSING: '处理中',
    OP_SOLVED: '已解决'
};

const officialProcessOptions = [
    {
        label: officialProcessMap.OP_PENDING,
        value: 'OP_PENDING'
    },
    {
        label: officialProcessMap.OP_PROCESSING,
        value: 'OP_PROCESSING'
    },
    {
        label: officialProcessMap.OP_SOLVED,
        value: 'OP_SOLVED'
    }
];

const metaInfo = {
    fixedWords: '智能小程序开发者社区,开发者社区,小程序社区,小程序定值,小程序API,小程序开发工具,小程序开发源码,小程序,小程序开发,智能小程序,百度小程序'
};

const routeTarget =  '_blank';

// 滑动验证码接入的appkey
const mkdAppkey = '7ba0774351d018d3613a6fbad0ebbe1b';

export default {
    wordLimit,
    officialProcessOptions,
    metaInfo,
    routeTarget,
    mkdAppkey,
};
